export const storedUser = JSON.parse(localStorage.getItem("userCredentials"));
